import React, { Component } from 'react';
import trim from 'lodash/trim';

class ReduxField extends Component {
  _dropDownChange = (event) => {
    const {
      input: { name },
      _dropDownChange,
    } = this.props;
    _dropDownChange({ name, value: event.target.value });
  };

  render() {
    const {
      input, type = 'text', meta, _dropDownChange = null, ...rest
    } = this.props;
    return (
      <>
        {type === 'dropdown' ? (
          <select className="form-control" {...rest} {...input} {...(_dropDownChange ? { onChange: this._dropDownChange } : {})}>
            {rest.placeholder && <option value="">{rest.placeholder}</option>}
            {rest.data.map((value, key) => (
              <option key={`reduxDropdown${key}`} value={key}>{value}</option>
            ))}
          </select>
        ) : null}

        {['text', 'number', 'password', 'checkbox', 'radio', 'hidden'].includes(type) ? (
          <input {...rest} {...input} type={type} />
        ) : type === 'textarea' ? (
          <textarea {...rest} {...input} />
        ) : null}

        {meta.touched && meta.error && (
          <span className="text-danger small">
            <i className="fa fa-exclamation-circle text-danger" />
            &nbsp;&nbsp;
            {meta.error}
          </span>
        )}
      </>
    );
  }
}

export const renderField = (props) => <ReduxField {...props} />;

export const required = (value) => (trim(value) ? undefined : '*Required');

export const requiredSelect = (value) => (trim(value) ? undefined : '*Required');

export const passwordsMustMatch = (value, allValues) => (value !== allValues.password ? 'Password Mismatch' : undefined);

export const passwordMaxLength = (value) => (value && !/^.{6,}$/i.test(value) ? 'Password at least 6 chars long' : undefined);

export const validateWhiteSpace = (value) => (value && !/^\S+$/i.test(value) ? "Password can't allow white space" : undefined);

export const passwordExtraMatches = (value) => (
  value && !/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}/.test(value)
    ? 'Password must be at least 1 uppercase letter, 1 lowercase and 1 number & 8 char long'
    : undefined
);

export const validateLink = (value) => (
  value && /^https?:\/\/(?:www\.)?[a-z0-9\-\.]{3,}\.[a-z]{2,}(?:(?:\/|\?)[^\s]*)?$/i.test(value) // eslint-disable-line
);

export const linkValidation = (value) => (
  value && !/^https?:\/\/(?:www\.)?[a-z0-9\-\.]{3,}(?<!\.)\.[a-z]{2,}(?:(?:\/|\?)[^\s]*)?$/.test(value) // eslint-disable-line
    ? 'Enter Correct URL'
    : undefined
);

export const email = (value) => (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? 'Invalid email address' : undefined);

export const name = (value) => (value && !/^[a-zA-Z. ]*$/i.test(value) ? 'Alphabets, space & dots are allowed' : undefined);

export const zipCodeMaxLength = (value) => (value && !/^.{4,5}$/i.test(value) ? 'Zipcode min4 & max 5 chars long' : undefined);

export const nameMaxLength = (value) => (value && !/^.{1,100}$/i.test(value) ? 'Max 100 characters are allowed in name' : undefined);

export const emailMaxLength = (value) => (value && !/^.{1,100}$/i.test(value) ? 'Max 100 characters are allowed in email' : undefined);

export const priceOnlyPositive = (value) => (value && !/^(?=.*[1-9])\d*\.?[0]{0,2}$/i.test(value) ? 'The minimum price should be 1!' : undefined);

export const priceOnlyPositiveAndDecimal = (value) => (
  value && !/^(?=.*[1-9])\d*\.?[0-9]{0,2}$/i.test(value) ? 'The minimum price should be 1!' : undefined
);

export const priceQuantityMaxLength = (value) => (value && !/^.{1,10}$/i.test(value) ? 'Maximum of 10 digit!' : undefined);

export const positiveNumber = (value) => (value && !/^\d*[1-9]\d*$/i.test(value) ? 'The minimum quantity should be 1!' : undefined);

export const priceMaxLength = (value) => (value && !/^.{1,14}$/i.test(value) ? 'Maximum of 14 digit!' : undefined);

export const preventScientificLetters = (ev) => {
  ['.', 'e', 'E', '+', '-'].includes(ev.key) && ev.preventDefault();
};

export const PortMaxLength = (value) => (value && !/^.{1,5}$/i.test(value) ? 'Maximum of 5 digit!' : undefined);

export const InputMaxLength = (value) => (value && !/^.{1,500}$/i.test(value) ? 'Max 500 characters are allowed' : undefined);

export const OTPMaxLength = (value) => (value && !/^.{1,6}$/i.test(value) ? 'Maximum of 6 digit!' : undefined);

export const IndMobileNumber = (value) => (value && !/^[6-9]\d{9}$/i.test(value) ? 'Enter valid phone number' : undefined);

export const textAreaMaxLength = (value) => (value && !/^.{1,150}$/i.test(value) ? 'Max 150 characters are allowed' : undefined);
